import { Html } from '@react-three/drei';
import React from 'react';
export var TextThreeRendering = function (_a) {
    var position = _a.position, text = _a.text, _b = _a.backgroundColor, backgroundColor = _b === void 0 ? 'rgba(255, 255, 255, 0.8)' : _b, color = _a.color;
    var HEIGHT = 8;
    var ELEVATION = 0;
    var positionZ = HEIGHT / 2 + ELEVATION;
    var _c = React.useState(false), isHovered = _c[0], setIsHovered = _c[1];
    var handlePointerOver = function () {
        setIsHovered(true);
    };
    var handlePointerOut = function () {
        setIsHovered(false);
    };
    var scaleFactor = isHovered ? 2 : 1.0;
    var positionX = text && text.length > 5 ? -2 : -1;
    return (React.createElement(React.Fragment, null,
        React.createElement("mesh", { position: position },
            React.createElement("mesh", { position: [positionX, 0, positionZ] }, text && (React.createElement(Html, { zIndexRange: [0, 0, 1] }, text && (React.createElement("div", { style: {
                    backgroundColor: backgroundColor,
                    color: color !== null && color !== void 0 ? color : undefined,
                    padding: '0.2rem 0.5rem',
                    borderRadius: '4px',
                    fontSize: '0.6rem',
                    transform: "scale(".concat(scaleFactor, ")"),
                    transition: 'transform 0.6s cubic-bezier(0.2, 0.8, 0.2, 1)',
                }, onPointerOver: handlePointerOver, onPointerOut: handlePointerOut }, text))))))));
};
